export function setToken(token) {
    localStorage.setItem("token", token);
}
export function setUserId(userid) {
    localStorage.setItem("userid", userid);
}

// Recupera il token
export function getToken() {
    return localStorage.getItem("token");
}
export function getUserId() {
    return localStorage.getItem("userid");
}

export function removeToken() {
    localStorage.removeItem("token");
}
export function removeUserId() {
    localStorage.removeItem("userid");
}
export function setSidebar(valore) {
    localStorage.setItem("sidebar", valore);
}
export function getSidebar() {
    return localStorage.getItem("sidebar");
}
export function getInizioPeriodo() {
    return localStorage.getItem("inizioPeriodo");
}
export function getDataPlan() {
    return localStorage.getItem("dataPlan");
}
export function setDataPlan(valore) {
    localStorage.setItem("dataPlan", valore);
}
export function getFinePeriodo(){
    return localStorage.getItem("finePeriodo");
}
export function setInizioPeriodo(valore) {
    localStorage.setItem("inizioPeriodo", valore);
}
export function setFinePeriodo(valore) {
    localStorage.setItem("finePeriodo", valore);
}
export function getInizio() {
    return localStorage.getItem("inizio");
}
export function getFine(){
    return localStorage.getItem("fine");
}
export function setInizio(valore) {
    localStorage.setItem("inizio", valore);
}
export function setFine(valore) {
    localStorage.setItem("fine", valore);
}
export function getInizioC() {
    return localStorage.getItem("inizioC");
}
export function getFineC(){
    return localStorage.getItem("fineC");
}
export function setInizioC(valore) {
    localStorage.setItem("inizioC", valore);
}
export function setFineC(valore) {
    localStorage.setItem("fineC", valore);
}
export function getIndiceStorico(){
return localStorage.getItem("indiceStorico");
}
export function setIndiceStorico(valore) {
    localStorage.setItem("indiceStorico", valore);
}
export function getIndiceStoricoVilla(){
return localStorage.getItem("indiceStoricoVilla");
}
export function setIndiceStoricoVilla(valore) {
    localStorage.setItem("indiceStoricoVilla", valore);
}
export function getRuolo(){
return localStorage.getItem("zona");
}
export function setRuolo(valore) {
    localStorage.setItem("zona", valore);
}
export function setLingua(valore){
     localStorage.setItem("lingua", valore);
}
export function getLingua(){
    return localStorage.getItem("lingua")
}
export function setPagina(valore){
     localStorage.setItem("ambiente", valore);
}
export function getPagina(){
    return localStorage.getItem("ambiente")
}
export function getInizioPIstr() {
    return localStorage.getItem("inizioPIstr");
}
export function getFinePIstr(){
    return localStorage.getItem("finePIstr");
}
export function setInizioPIstr(valore) {
    localStorage.setItem("inizioPIstr", valore);
}
export function setFinePIstr(valore) {
    localStorage.setItem("finePIstr", valore);
}
export function getIndiceStoricoSpeseVilla(){
    return localStorage.getItem("indSpVil");
}
export function setIndiceStoricoSpeseVilla(valore) {
    localStorage.setItem("indSpVil", valore);
}
export function getIndiceAnalisiSpeseVilla(){
    return localStorage.getItem("indAnVil");
}
export function setIndiceAnalisiSpeseVilla(valore) {
    localStorage.setItem("indAnVil", valore);
}


